export const FETCH_MINE_LISTINGS = 'FETCH_MINE_LISTINGS';
export const FETCH_MINE_LISTINGS_SUCCESS = 'FETCH_MINE_LISTINGS_SUCCESS';
export const FETCH_MINE_LISTINGS_ERROR = 'FETCH_MINE_LISTINGS_ERROR';
export const FETCH_MINE_PARENTS = 'FETCH_MINE_PARENTS';
export const FETCH_MINE_PARENTS_SUCCESS = 'FETCH_MINE_PARENTS_SUCCESS';
export const FETCH_MINE_PARENTS_ERROR = 'FETCH_MINE_PARENTS_ERROR';

type MineAttributes = {
  loading: boolean;
  data: number[];
};

export interface MineState {
  listings: MineAttributes;
  parents: MineAttributes;
}

interface FetchMineListings {
  type: typeof FETCH_MINE_LISTINGS;
}

interface FetchMineListingsSuccess {
  type: typeof FETCH_MINE_LISTINGS_SUCCESS;
  listings: number[];
}

interface FetchMineListingsError {
  type: typeof FETCH_MINE_LISTINGS_ERROR;
}

interface FetchMineParents {
  type: typeof FETCH_MINE_PARENTS;
}

interface FetchMineParentsSuccess {
  type: typeof FETCH_MINE_PARENTS_SUCCESS;
  data: number[];
}

interface FetchMineParentsError {
  type: typeof FETCH_MINE_PARENTS_ERROR;
}

export type MineActionTypes =
  | FetchMineListings
  | FetchMineListingsSuccess
  | FetchMineListingsError
  | FetchMineParents
  | FetchMineParentsSuccess
  | FetchMineParentsError;
